// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"7bf8bd5c","313":"96ea1094","322":"697e73cb","549":"0defdc4d"}[chunkId] + ".chunk.js";
};